import * as React from "react";
const SvgCompletedOrderStatus = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", ...props }, /* @__PURE__ */ React.createElement("circle", { cx: 8, cy: 8, r: 7, fill: "#52C41A" }));
export default SvgCompletedOrderStatus;
